module.exports = __webpack_public_path__ + "static/media/Slide3.47832f2b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide3.webp
// module id = 576
// module chunks = 4